<template>
  <v-container style="border-radius: 10px;" fluid>
    <v-btn @click="reset()">Reset dates</v-btn>
    <!-- Existing date config -->
    <div v-if="currentOffer != null && currentDates.length >= 10">
      <v-card class="date-card">
        <div class="date-card__flex-box">
          <div class="date-card__flex-box--h1">
            <h1 style="font-weight: 300;">Start</h1>
            {{moment(currentDates[0].startDate).format("dddd Do MMMM YYYY")}}
          </div>
          <div class="date-card__flex-box--h1">
            <h1 style="font-weight: 300;">End</h1>
            {{moment(
            currentDates[0].endDate
            ).format("dddd Do MMMM YYYY")}}
          </div>
        </div>
        <v-btn block tile class="accent" @click="reset()">Remove</v-btn>
      </v-card>
    </div>
    <div
      v-if="currentOffer != null && currentDates.length <= 10 && currentDates.length > 0"
      class="date-chip"
      style="text-align: center;"
    >
      <h2 class="mb-4" style="font-weight: 300;">Existing dates</h2>
      <v-chip
        v-for="(date, index) in currentDates"
        :key="`${index}-${date.rid}`"
        close
        @click:close="remove(index, date.rid)"
        class="ma-3"
      >{{ moment(date.startDate).format("dddd Do MMMM YYYY")}}</v-chip>
    </div>
    <v-container class="pa-3">
      <v-row no-gutters>
        <v-col md="12">
          <v-row justify="center">
            <v-col cols="12" md="1">
              <v-subheader>From</v-subheader>
            </v-col>
            <v-col cols="6" md="2">
              <v-select
                v-model="start.hour"
                :items="hourItems"
                :rules="rules.hourRules"
                :menu-props="{ auto: true }"
                append-icon
                outlined
                solo
                flat
                rounded
              />
            </v-col>
            <v-col cols="6" md="2">
              <v-select
                v-model="start.minute"
                :items="minuteItems"
                :rules="rules.minuteRules"
                :menu-props="{ auto: true }"
                append-icon
                placeholder="12:00"
                outlined
                solo
                flat
                rounded
              />
            </v-col>

            <v-col cols="12" md="1">
              <v-subheader>Until</v-subheader>
            </v-col>
            <v-col cols="6" md="2">
              <v-select
                v-model="end.hour"
                :items="hourItems"
                :rules="rules.hourRules"
                :menu-props="{ auto: true }"
                append-icon
                outlined
                solo
                flat
                rounded
              />
            </v-col>

            <v-col cols="6" md="2">
              <v-select
                v-model="end.minute"
                :items="minuteItems"
                :menu-props="{ auto: true }"
                :rules="rules.minuteRules"
                outlined
                solo
                flat
                rounded
                append-icon
              />
            </v-col>
          </v-row>
          <v-divider />

          <div class="calendar">
            <v-date-picker
              multiple
              v-model="days"
              no-title
              solo
              :show-current="false"
              :landscape="$vuetify.breakpoint.smAndUp"
              class="calendar__picker"
            ></v-date-picker>
            <v-menu ref="menu" :close-on-content-click="false" :return-value.sync="days">
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-model="days"
                  multiple
                  chips
                  label="Selected dates"
                  v-on="on"
                  class="calendar__combo"
                ></v-combobox>
              </template>
            </v-menu>
          </div>

          <div style="display: flex; justify-content: center;">
            <v-btn text small @click="advanced = !advanced" class="ma-4">Advanced options</v-btn>
          </div>

          <div v-if="advanced">
            <v-row>
              <v-col md="8" class="pa-0 mt-12">
                <v-row no-gutters>
                  <v-col cols="5" md="2" class="pa-0">
                    <v-subheader>Recur every</v-subheader>
                  </v-col>
                  <v-col cols="6" md="3" class="pa-0">
                    <v-select
                      :items="recurrenceItems"
                      placeholder="Daily"
                      v-model="recurrence.type"
                      append-icon
                      outlined
                      solo
                      flat
                      rounded
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- Daily-->
            <v-row no-gutters>
              <v-col v-if="recurrence.type == 'Day'" cols="12" md="8" class="pa-0"></v-col>

              <!-- Weekly -->
              <v-col v-if="recurrence.type == 'Week'" cols="12" md="8" class="pa-0">
                <v-row>
                  <v-row>
                    <v-col cols="5" md="2" class="pl-3 py-0">
                      <v-subheader>Every</v-subheader>
                    </v-col>
                    <v-col cols="2" md="2" class="pl-1 py-0">
                      <v-text-field
                        type="number"
                        v-model="recurrence.weekOccurences"
                        outlined
                        solo
                        flat
                        rounded
                        style="margin-left: 10px; width: 50px"
                      ></v-text-field>
                    </v-col>

                    <v-col md="3" class="pa-0">
                      <v-subheader>week(s)</v-subheader>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="2" class="pl-3 pt-0">
                      <v-subheader>on:</v-subheader>
                    </v-col>
                    <v-col class="pa-0">
                      <v-btn-toggle
                        multiple
                        v-model="recurrence.selectedDay"
                        background-color="#f1f1f1"
                        class="mt-2"
                        style="width: 100%;"
                      >
                        <v-chip>
                          <v-btn
                            v-for="(day, index) in dayItems"
                            :key="index"
                            style="font-size: 10px;"
                            text
                          >{{ day }}</v-btn>
                        </v-chip>
                      </v-btn-toggle>
                    </v-col>
                  </v-row>
                </v-row>
              </v-col>

              <!-- Fortnight -->
              <v-col v-if="recurrence.type == 'Fortnight'" cols="12" md="8" class="pa-0"></v-col>

              <!-- Monthly -->
              <v-col v-if="recurrence.type == 'Month'" md="8" class="pa-0">
                <v-row no-gutters>
                  <v-col>
                    <v-checkbox
                      label="Last day of month"
                      v-model="recurrence.monthlyRecurrence"
                      value="lastDay"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="5">
                    <v-checkbox
                      label="This day of month"
                      v-model="recurrence.monthlyRecurrence"
                      value="thisDayOfMonth"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      v-if="recurrence.monthlyRecurrence === 'thisDayOfMonth'"
                      :items="daysOfMonthItems"
                      v-model="recurrence.dayOfMonth"
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <v-checkbox
                      label="This day of week"
                      v-model="recurrence.monthlyRecurrence"
                      value="thisDayOfWeek"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-col class="pa-0">
                  <v-btn-toggle
                    v-if="recurrence.monthlyRecurrence === 'thisDayOfWeek'"
                    v-model="recurrence.selectedWeek"
                    class="mb-3"
                    background-color="#f1f1f1"
                    style="width: 80%;"
                  >
                    <v-chip>
                      <v-btn
                        v-for="(week, index) in weekItems"
                        :key="index"
                        text
                        style="font-size: 10px; width: 110px;"
                      >{{ week }}</v-btn>
                    </v-chip>
                  </v-btn-toggle>

                  <v-btn-toggle
                    v-if="recurrence.monthlyRecurrence === 'thisDayOfWeek'"
                    dense
                    multiple
                    v-model="recurrence.selectedDay"
                    background-color="#f1f1f1"
                  >
                    <v-chip>
                      <v-btn
                        v-for="(day, index) in dayItems"
                        :key="index"
                        style="font-size: 10px;"
                        text
                      >{{ day }}</v-btn>
                    </v-chip>
                  </v-btn-toggle>
                </v-col>
              </v-col>

              <!-- Yearly -->
              <v-col v-if="recurrence.type == 'Year'" md="8" class="pa-0">
                <v-row>
                  <v-row>
                    <v-col md="1" class="pa-0">
                      <v-subheader>every</v-subheader>
                    </v-col>
                    <v-col md="1" class="pa-0">
                      <input type="number" v-model="recurrence.yearOccurences" solo flat />
                    </v-col>
                    <v-col md="1" class="pa-0">
                      <v-subheader>year(s)</v-subheader>
                    </v-col>
                  </v-row>
                </v-row>
              </v-col>

              <v-col
                v-if="recurrence.type"
                cols="12"
                md="4"
                :class="{ 'end-config-md': this.$vuetify.breakpoint.md }"
              >
                <v-row style="position: relative; top: -80px;">
                  <v-col cols="3" md="5" class="pa-0">
                    <v-subheader
                      :class="{ 'start-txt-xs': this.$vuetify.breakpoint.xs }"
                    >Start date:</v-subheader>
                  </v-col>
                  <v-col
                    cols="4"
                    md="6"
                    class="pa-0"
                    :class="{ 'start-field-xs': this.$vuetify.breakpoint.xs }"
                  >
                    <v-menu>
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          type="text"
                          v-on="on"
                          placeholder="01/01/2019"
                          :value="formatStart"
                          :rules="rules.dateRules"
                          outlined
                          solo
                          flat
                          rounded
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-if="recurrence.type === 'Month'"
                        v-model="start.date"
                        no-title
                        type="month"
                      ></v-date-picker>

                      <v-date-picker v-model="start.date" no-title></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <div
                  :class="{
                    'end-sec-xs': this.$vuetify.breakpoint.xs
                  }"
                >
                  <v-row no-gutters>
                    <v-col cols="3" md="5" class="pa-0">
                      <v-checkbox label="End by:" v-model="recurrence.endType" value="date"></v-checkbox>
                    </v-col>
                    <v-col cols="4" md="6" class="pa-0">
                      <v-menu>
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            type="text"
                            v-on="on"
                            readonly
                            outlined
                            solo
                            flat
                            rounded
                            placeholder="01/01/2019"
                            :value="formatEnd"
                            :rules="rules.dateRules"
                            :disabled="disableInput"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-if="recurrence.type === 'Month'" no-title></v-date-picker>
                        <v-date-picker v-model="end.date" no-title></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="3" md="5" class="pa-0">
                      <v-checkbox
                        label="End after:"
                        v-model="recurrence.endType"
                        value="occurences"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="1" md="2" class="pa-0">
                      <input
                        type="number"
                        v-model="recurrence.endAfterOccurences"
                        style="width: 50px"
                      />
                    </v-col>
                    <v-col md="2">
                      <v-subheader>occurences</v-subheader>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col md="5" class="pa-0">
                      <v-checkbox label="No end date" value="none" v-model="recurrence.endType"></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-divider v-if="advanced" />

      <div v-if="advanced && datesArray.length > 0" class="review-dates">
        <span v-if="recurrence.type === 'Day'" style="font-weight: 200;">Repeat every day</span>

        <span
          v-if="
            recurrence.type === 'Week' && recurrence.selectedDay.length >= 1
          "
          style="font-weight: 200;"
        >
          Repeat every
          <span
            v-if="recurrence.weekOccurences > 1"
          >{{ recurrence.weekOccurences }} weeks on</span>
          <span v-for="(day, index) in recurrence.selectedDay" :key="index">
            <span
              v-if="
                index > 0 &&
                  recurrence.selectedDay.length > 2 &&
                  index !== recurrence.selectedDay.length - 1
              "
            >,</span>
            <span v-if="index > 0 && index === recurrence.selectedDay.length - 1">and</span>
            {{
            moment()
            .day(day + 1)
            .format("dddd")
            }}
          </span>
        </span>

        <span
          v-if="recurrence.type === 'Fortnight'"
          style="font-weight: 200;"
        >Repeat every fortnight</span>

        <span v-if="recurrence.type === 'Month'" style="font-weight: 200;">
          <span
            v-if="recurrence.monthlyRecurrence === 'lastDay'"
          >Repeat on the last day of every month</span>
          <span
            v-if="
              recurrence.monthlyRecurrence === 'thisDayOfMonth' &&
                recurrence.dayOfMonth !== null
            "
          >
            Repeat on the
            {{
            moment()
            .startOf("month")
            .add("day", recurrence.dayOfMonth - 1)
            .format("Do")
            }}
            of every month
          </span>
        </span>

        <span
          v-if="
            recurrence.monthlyRecurrence === 'thisDayOfWeek' &&
              recurrence.selectedWeek &&
              recurrence.selectedDay
          "
        >
          Repeat on the
          <span v-if="recurrence.selectedWeek == 0">first</span>
          <span v-if="recurrence.selectedWeek == 1">second</span>
          <span v-if="recurrence.selectedWeek == 2">third</span>
          <span v-if="recurrence.selectedWeek == 3">final</span>
          <span v-for="(day, index) in recurrence.selectedDay" :key="index">
            <span
              v-if="
                index > 0 &&
                  recurrence.selectedDay.length > 2 &&
                  index !== recurrence.selectedDay.length - 1
              "
            >,</span>
            <span v-if="index > 0 && index === recurrence.selectedDay.length - 1">and</span>
            {{
            moment()
            .day(day + 1)
            .format("dddd")
            }}
          </span>
          of every month
        </span>
        <span>
          between
          {{
          moment()
          .hour(start.hour)
          .format("h")
          }}:{{ start.minute }}
          <span
            v-if="start.hour <= 12"
          >am</span>
          <span v-else>pm</span>
          -
          {{
          moment()
          .hour(end.hour)
          .format("h")
          }}:{{ end.minute }}
          <span
            v-if="end.hour <= 12"
          >am</span>
          <span v-else>pm</span>
          from
          {{ moment(start.date).format("DD-MM-YYYY") }} until
          {{ moment(end.date).format("DD-MM-YYYY") }}.
        </span>
      </div>
    </v-container>
  </v-container>
</template>

<script>
import moment from "moment";
const uuid = require("uuid/v4");

export default {
  props: { currentOffer: Object, rules: Object },

  data() {
    return {
      start: {
        date: null,
        hour: 12,
        minute: "00"
      },

      end: {
        date: null,
        hour: 12,
        minute: "00"
      },

      // Individual date object
      days: [],

      // Recurring dates object

      recurrence: {
        start: null,
        end: null,
        type: null,
        endType: null,
        endAfterOccurences: 1,
        weekOccurences: 1,
        yearOccurences: 1,
        selectedDay: [],
        selectedWeek: "",
        dayOfMonth: null,
        monthlyRecurrence: null
      },

      dayItems: ["M", "T", "W", "T", "F", "S", "S"],
      minuteItems: ["00", "15", "30", "45"],
      recurrenceItems: ["Day", "Week", "Fortnight", "Month", "Year"],
      weekItems: ["First", "Second", "Third", "Last"],
      hourItems: [],
      monthItems: [],
      daysOfMonthItems: [],

      currentDates: this.currentOffer != null ? this.currentOffer.dates : [],
      datesArray: [],
      calendarDays: [],

      showMonth: false,
      advanced: false
    };
  },

  methods: {
    generateDates(date) {
      this.datesArray.push(date);
      this.$emit("generateDates", date);
    },

    // Advanced config
    createDateArray(amount, unit) {
      const initialStart = this.recurrence.start.clone();
      let end = null;
      let start = this.recurrence.start.clone();

      if (this.recurrence.endType === "none") {
        end = initialStart.clone().add(1, "Year");
      } else if (
        this.recurrence.endType === "occurences" &&
        this.recurrence.endAfterOccurences
      ) {
        end = initialStart
          .clone()
          .add(this.recurrence.endAfterOccurences, unit);
      } else {
        end = this.recurrence.end.clone();
      }

      switch (this.recurrence.type) {
        case "Day":
          while (start.add(amount, unit).diff(end) <= 0) {
            let addDate = {
              start: start.clone(),
              end: moment(end.clone()).set({
                hour: end.hour(),
                minute: end.minute()
              })
            };
            this.datesArray.push(addDate);
            this.$emit("generateDates", addDate);
          }

          break;

        case "Week":
          if (this.recurrence.endType === "occurences") {
            for (let i = 0; i <= this.recurrence.endAfterOccurences; i++) {
              start.add(this.recurrence.weekOccurences, unit);
              this.recurrence.selectedDay.forEach(dayInt => {
                const date = start.clone().day(dayInt + 1);
                if (!date.isBefore(initialStart)) {
                  let addDate = {
                    start: start.clone().day(dayInt + 1),
                    end: moment(end.clone().day(dayInt + 1)).set({
                      hour: end.hour(),
                      minute: end.minute()
                    })
                  };
                  this.generateDates(date);
                }
              });
            }
          } else {
            while (
              start.add(this.recurrence.weekOccurences, unit).diff(end) <= 0
            ) {
              if (this.recurrence.weekOccurences) {
                this.recurrence.selectedDay.forEach(dayInt => {
                  const date = start.clone().day(dayInt + 1);

                  if (!date.isBefore(initialStart)) {
                    let addDate = {
                      start: start.clone().day(dayInt + 1),
                      end: moment(end.clone().day(dayInt + 1)).set({
                        hour: end.hour(),
                        minute: end.minute()
                      })
                    };
                    this.generateDates(addDate);
                  }
                });
              }
            }
          }

          break;

        case "Fortnight":
          while (start.add(amount, unit).diff(end) <= 0) {
            let addDate = {
              start: start.clone(),
              end: end.clone().set({
                hour: end.hour(),
                minute: end.minute()
              })
            };
            this.generateDates(addDate);
          }

          break;

        case "Month":
          if (this.recurrence.monthlyRecurrence === "lastDay") {
            let addDate = {
              start: start.clone().endOf("month"),
              end: end.clone().set({ hour: end.hour(), minute: end.minute() })
            };

            this.generateDates(addDate);

            if (this.recurrence.endType === "occurences") {
              for (let i = 0; i <= this.recurrence.endAfterOccurences; i++) {
                start.add(amount, unit);
                this.datesArray.push({
                  start: start.clone().endOf("month"),
                  end: end.clone().set({
                    hour: end.hour(),
                    minute: end.minute()
                  })
                });
              }
            } else {
              while (start.add(amount, unit).diff(end) <= 0) {
                this.datesArray.push({
                  start: start.clone().endOf("month"),
                  end: end.clone().set({
                    hour: end.hour(),
                    minute: end.minute()
                  })
                });
              }
            }
          }

          if (this.recurrence.monthlyRecurrence === "thisDayOfWeek") {
            if (this.recurrence.endType === "occurences") {
              for (let i = 0; i <= this.recurrence.endAfterOccurences; i++) {
                start.add(amount, unit);
                this.recurrence.selectedDay.forEach(dayInt => {
                  const date = start.clone().day(dayInt + 1);

                  if (!date.isBefore(initialStart)) {
                    let addDate = {
                      start: start.clone().day(dayInt + 1),
                      end: end.clone().set({
                        hour: end.hour(),
                        minute: end.minute()
                      })
                    };
                    this.generateDates(addDate);
                  }
                });
              }
            } else {
              if (this.recurrence.selectedWeek === 3) {
                let newDay = null;
                while (start.add(amount, unit).diff(end) <= 0) {
                  this.recurrence.selectedDay.forEach(dayInt => {
                    let endOfMonth = start
                      .clone()
                      .endOf("month")
                      .startOf("day");
                    while (endOfMonth.isoWeekday() !== dayInt + 1) {
                      endOfMonth.subtract(1, "days");
                    }

                    newDay = endOfMonth;

                    let addDate = {
                      start: newDay.set({
                        hour: start.hour(),
                        minute: start.minute()
                      }),
                      end: end.clone().set({
                        hour: end.hour(),
                        minute: end.minute()
                      })
                    };
                    this.generateDates(addDate);
                  });
                }
              } else {
                while (start.add(amount, unit).diff(end) <= 0) {
                  let firstMonday = start
                    .clone()
                    .startOf("month")
                    .day("monday");

                  if (!moment(firstMonday).isSame(start, "month")) {
                    firstMonday.add(1, "Week");
                  }

                  let mondayOfWeek = firstMonday.add(
                    this.recurrence.selectedWeek,
                    "Week"
                  );

                  this.recurrence.selectedDay.forEach(dayInt => {
                    let newDay = mondayOfWeek.clone().add(dayInt, "Day");
                    let addDate = {
                      start: newDay.set({
                        hour: start.hour(),
                        minute: start.minute()
                      }),
                      end: end.clone().set({
                        hour: end.hour(),
                        minute: end.minute()
                      })
                    };
                    this.generateDates(addDate);
                  });
                }
              }
            }
          } else if (this.recurrence.monthlyRecurrence === "thisDayOfMonth") {
            for (let i = 1; i <= start.daysInMonth(); i++) {
              this.daysOfMonthItems.push(i);
            }

            if (this.recurrence.endType === "occurences") {
              for (let i = 0; i <= this.recurrence.endAfterOccurences; i++) {
                start.add(amount, unit);
                let addDate = {
                  start: start.clone().date(this.recurrence.dayOfMonth),
                  end: end.clone().set({
                    hour: end.hour(),
                    minute: end.minute()
                  })
                };
                this.generateDates(addDate);
              }
            }

            while (start.add(amount, unit).diff(end) <= 0) {
              let addDate = {
                start: start.clone().date(this.recurrence.dayOfMonth),
                end: end.clone().set({
                  hour: end.hour(),
                  minute: end.minute()
                })
              };
              this.generateDates(addDate);
            }
          }

          break;

        case "Year":
          while (
            start.add(this.recurrence.yearOccurences, unit).diff(end) <= 0
          ) {
            let addDate = {
              start: start.clone(),
              end: end.clone().set({
                hour: end.hour(),
                minute: end.minute()
              })
            };
            this.generateDates(addDate);
          }

          break;
      }
    },

    amountFromType(type) {
      if (type == "Fortnight") {
        return 2;
      } else {
        return 1;
      }
    },

    unitFromType(type) {
      if (type == "Fortnight") {
        return "week";
      } else {
        return type;
      }
    },

    selectedChip(index) {
      let selected = this.datesArray.filter(date => {
        return date.index == index;
      });

      return selected.length > 0 ? "primary" : "";
    },

    makeDark(index) {
      let selected = this.datesArray.filter(date => {
        return date.index == index;
      });

      return selected.length > 0;
    },

    remove(index, rid) {
      this.datesArray.splice(index, 1);
      this.$emit("remove", rid);
    },

    reset() {
      this.datesArray = [];
      this.$emit("reset");
    },

    disableDate(index) {
      let today = new Date();
      if (index < moment().date() - 1) {
        return true;
      }
    }
  },

  computed: {
    formatStart() {
      return this.start.date
        ? moment(this.start.date).format("DD/MM/YYYY")
        : "";
    },

    formatEnd() {
      return this.end.date ? moment(this.end.date).format("DD/MM/YYYY") : "";
    },

    disableInput() {
      if (this.recurrence.endType != "date") {
        return true;
      }
    }

    // clearDates() {
    //   this.datesArray = [];
    // }
  },

  watch: {
    days: function(val) {
      let formattedDay;
      val.forEach(day => {
        formattedDay = {
          start: moment(day).set({
            hour: this.start.hour,
            minute: this.start.minute
          }),
          end: moment(day).set({
            hour: this.end.hour,
            minute: this.end.minute
          })
        };
      });
      this.$emit("generateDay", formattedDay);
    },

    start: {
      handler: function(val) {
        this.recurrence.start = moment(`${val.date} ${val.hour}:${val.minute}`);
      },
      deep: true
    },

    end: {
      handler: function(val) {
        this.recurrence.end = moment(`${val.date} ${val.hour}:${val.minute}`);
      },

      deep: true
    },

    recurrence: {
      handler: function(val) {
        this.datesArray = [];
        this.reset();
        if (val.endType == "date") {
          this.createDateArray(
            this.amountFromType(val.type),
            this.unitFromType(val.type)
          );
        } else if (val.endType == "occurences") {
          this.createDateArray(
            this.amountFromType(val.type),
            this.unitFromType(val.type)
          );
        } else if (val.endType == "none") {
          this.createDateArray(
            this.amountFromType(val.type),
            this.unitFromType(val.type)
          );
        } else {
          return;
        }
      },
      deep: true
    }
  },

  showMonth(val) {
    if (val) {
      let nextMonth = moment().add(1, "month");
      for (let i = 0; i <= nextMonth.daysInMonth(); i++) {
        this.calendarDays.push(i);
      }
    }
  },

  mounted() {
    console.log(this.currentDates);
    for (let i = 1; i <= moment().daysInMonth(); i++) {
      this.calendarDays.push(i);
    }

    for (let i = 0; i < 24; i++) {
      this.hourItems.push(i);
    }

    this.hourItems[0] = "00";

    for (let i = 1; i <= 12; i++) {
      this.monthItems.push(i);
    }

    this.start.date = moment().format("YYYY-MM-DD");
    this.end.date = moment().format("YYYY-MM-DD");
  }
};
</script>

<style lang="sass" scoped>

.calendar
  display: flex
  flex-flow: row
  align-items: center
  justify-content: center
  padding: 30px

  &__picker
    width: 300px
    margin: 10px 20px 0 0

  &__combo
    max-width: 400px

.date-card
  border: 5px solid #3F51B5
  background-color: #f7f7f7

  &__flex-box
    display: flex
    flex-direction: row
    justify-content: space-around

    &--h1
      text-align: center


.start-txt-xs
  position: relative
  top: 120px

.start-field-xs
  position: relative
  top: 170px
  left: -90px


.end-sec-xs
  position: relative
  top: 10px
  left: 170px

.review-dates
  background-color: #3f51b5
  color: #fff
  border-radius: 8px
  padding: 10px
  font-size: 40px
  font-weight: 200

</style>
